export default function UnknownIcon() {
  return (
    <svg
      width="16"
      className="unknown-icon"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="16"
        height="16"
        rx="8"
        fill="var(--basic-sep)"
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3C5.89543 3 5 3.89543 5 5V6H7V5H9V6.38197L8.10557 6.82918C7.428 7.16796 7 7.86049 7 8.61803V9H9L9 8.61803L9.89443 8.17082C10.572 7.83204 11 7.13951 11 6.38197V5C11 3.89543 10.1046 3 9 3H7ZM7 11V13H9V11H7Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
